import type { ICancelSupraSystemSubscriptionBody } from '@/app-package';
import axios from 'axios';

const cancelSupraSystemSubscription = async (
  body: ICancelSupraSystemSubscriptionBody,
) => {
  await axios.post<void>('/supra_system/subscription/cancel', body);
};

export default cancelSupraSystemSubscription;
